// Service API pour le Dashboard

import { DashboardSummary, PeriodeDashboard } from '../types/dashboard';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

/**
 * Récupère le token depuis le localStorage
 */
const getToken = (): string | null => {
  const stored = localStorage.getItem('momo_auth');
  if (stored) {
    try {
      const authState = JSON.parse(stored);
      return authState.token;
    } catch (e) {
      console.error('Erreur lors du parsing du token', e);
      return null;
    }
  }
  return null;
};

/**
 * Récupère le résumé du dashboard pour une période donnée
 */
export const fetchDashboardSummary = async (
  periode: PeriodeDashboard
): Promise<DashboardSummary> => {
  console.log('📡 fetchDashboardSummary - début');
  const token = getToken();

  if (!token) {
    console.log('❌ Token manquant dans le service');
    throw new Error('Token d\'authentification manquant');
  }

  const url = `${API_BASE_URL}/api/v1/dashboard/summary?period=${periode}`;
  console.log('🌐 URL de l\'API:', url);

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  console.log('📥 Réponse reçue - Status:', response.status);

  if (!response.ok) {
    const errorText = await response.text();
    console.log('❌ Erreur API:', errorText);
    throw new Error(
      `Erreur lors de la récupération du dashboard: ${response.status} - ${errorText}`
    );
  }

  const data: DashboardSummary = await response.json();
  console.log('✅ Données parsées:', data);
  return data;
};
